import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: 'plrTextClick,[plrTextClick],[(plrTextClick)]'
})
export class TextClick {

  @Output()
  plrTextClick = new EventEmitter<MouseEvent>();

  constructor() { }

  @HostListener('click', ['$event'])
  clickEvent(event: MouseEvent) {
    if (event.view.getSelection().type !== 'Range') {
      this.plrTextClick.emit(event);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pillar/common/directives/text-click.directive.ts